// extracted by mini-css-extract-plugin
export default {"font_button_l":"font_button_l___vNQxH","font_button_m":"font_button_m___eGAWI","font_button_s":"font_button_s___M9dvB","category_badge":"category_badge___CBYyF"};